export default () => [
  {
    field: "seq",
    width: 50,
    align: "center",
    fixed: "left",
    type: "seq",
  },
  {
    field: "saveStatus",
    align: "center",
    width: 100,
    title: "导入状态",
    slots: { default: "status" },
  },
  {
    field: 'errorMsg',
    align: 'center',
    headerAlign: 'center',
    title: '导入异常原因',
    width: 200,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'coolerNo',
    align: 'center',
    headerAlign: 'center',
    title: '冷藏箱编号',
    minWidth: 150,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: "coolerLength",
    width: 100,
    align: "center",
    title: "冷藏箱长度",
  },
  {
    field: 'coolerWidth',
    title: '冷藏箱宽度',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'coolerHeight',
    align: 'center',
    minWidth: 120,
    title: '冷藏箱高度',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'boxTypeName',
    align: 'center',
    minWidth: 120,
    title: '冷藏箱容量',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'coolerMaterialName',
    align: 'center',
    minWidth: 200,
    title: '材质',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
];
